import * as ApiHelper from "../../api/ApiHelper";
import { resolveApiUrl } from "../../utils/url/urlResolver";

export function removeBulkPreviewEntry(index: number): Promise<Response> {
  const apiUrl = resolveApiUrl(`/bulkupload/deleteEntry?position=${index}`);

  return fetch(apiUrl, {
    cache: "no-cache",
    credentials: "same-origin",
    method: "DELETE",
    mode: "cors",
    headers: {
      "content-type": "application/json",
      CSRFToken: ApiHelper.getCsrfValue(),
    },
    redirect: "follow",
  });
}
